import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Home, RefreshCw } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function PagamentoAnnullatoPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div
          className="max-w-xl w-full rounded-3xl border border-slate-600/40 p-10 bg-gradient-to-br from-slate-700/20 to-slate-800/5 backdrop-blur-md"
          data-testid="nexi-annullato-panel"
        >
          <div className="flex flex-col items-center gap-4 mb-6">
            <XCircle className="w-20 h-20 text-slate-400" />
            <h1 className="text-3xl font-bold text-center">Pagamento Annullato</h1>
            <p className="text-slate-300 text-center">
              Hai annullato l'operazione prima del completamento. Nessun importo è stato addebitato.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <Link
              to="/"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold py-3 rounded-xl transition-colors"
              data-testid="nexi-annullato-home-btn"
            >
              <Home className="w-4 h-4" />
              Torna alla home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold py-3 rounded-xl transition-colors"
              data-testid="nexi-annullato-retry-btn"
            >
              <RefreshCw className="w-4 h-4" />
              Riprova pagamento
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
